/**
 * Scroll-Padding hinzufügen
 *
 * Scroll-Padding wird dem HTML hinzugefügt um die korrekte Position von Sprungmarken bei Anker-Links bei fixed oder
 * sticky Header zu haben.
 *
 * @param {string} selector - Elemente die fixed oder sticky sind und über dem Content liegen.
 * @param {string} additionalSpacing - Zusätzliche Abstand damit der Content nicht direkt am Element fixed Element hängt
 *
 * @return {undefined}
 */
function nc_initScrollPadding(selector, additionalSpacing) {
    var moduleLogger = LoggerManager.get('scroll-padding').setPrefix('Selektor: ' + selector + '; Zusätzlicher Abstand: ' + additionalSpacing);
    moduleLogger.trace('INIT START');
    $(window).on('load resize', function () {
        nc_scrollPadding(selector, additionalSpacing);
    });
    moduleLogger.info('INIT ENDE');
}

/**
 * @see nc_initScrollPadding
 */
function nc_scrollPadding(selector, additionalSpacing) {
    var moduleLogger = LoggerManager.get('scroll-padding').setPrefix('Selektor: ' + selector + '; Zusätzlicher Abstand: ' + additionalSpacing);
    moduleLogger.trace('SCRIPT START');
        // Setzt die Höhe vom Selector und den zusätzlichen Abstand als Scroll-Padding an das HTML Element.
        $('html').css({'scroll-padding-top': $(selector).outerHeight(true) + parseInt(additionalSpacing, 10) + 'px'});
    moduleLogger.info('SCRIPT ENDE');
}